import { render, staticRenderFns } from "./QNewAgentAppsDataTable.vue?vue&type=template&id=dbbacea8&scoped=true&"
import script from "./QNewAgentAppsDataTable.vue?vue&type=script&lang=js&"
export * from "./QNewAgentAppsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QNewAgentAppsDataTable.vue?vue&type=style&index=0&id=dbbacea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbacea8",
  null
  
)

export default component.exports